import type { OnMount } from '@monaco-editor/react'
import Editor, { loader } from '@monaco-editor/react'
import * as monaco from 'monaco-editor'
import React, { useState } from 'react'

import CodeModal from '../CodeModal'
import { ResizableBox } from './ResizableBox'
import * as SC from './styles'

type CodeEditorProps = {
    code: string
    onChange: (code: string) => void
}

loader.config({ monaco })

const CodeEditor: React.FC<CodeEditorProps> = ({ code, onChange }) => {
    const [height, setHeight] = useState(200)
    const [isOpen, setIsOpen] = useState(false)
    const [isFocused, setIsFocused] = useState(false)

    const handleCodeChange = (value: string | undefined) => {
        onChange(value ?? '')
    }

    const handleEditorDidMount: OnMount = editor => {
        editor.onDidFocusEditorText(() => setIsFocused(true))
        editor.onDidBlurEditorText(() => setIsFocused(false))
    }

    const getCode = (code: string) => {
        onChange(code)
    }

    return (
        <SC.Container>
            <SC.Header>
                <SC.Title>PYTHON3</SC.Title>
                {/* <SC.Icon type="AIStar" size={20} onClick={() => setIsOpen(true)} color="var(--color-purple-500)" /> */}
            </SC.Header>
            <ResizableBox minHeight={100} maxHeight={800} defaultHeight={200} onHeightChange={val => setHeight(val)}>
                <SC.EditorWrapper isFocused={isFocused}>
                    <Editor
                        height={`${height - 12}px`}
                        language="python"
                        value={code}
                        theme="customTheme"
                        onChange={handleCodeChange}
                        onMount={handleEditorDidMount}
                        loading={<div>编辑器加载中...</div>}
                        options={{
                            fontSize: 14,
                            minimap: { enabled: false },
                            lineNumbers: 'on',
                            folding: true,
                            automaticLayout: true,
                            scrollBeyondLastLine: false,
                            tabSize: 2,
                            lineNumbersMinChars: 2
                        }}
                    />
                </SC.EditorWrapper>
            </ResizableBox>
            <CodeModal isOpen={isOpen} onClose={() => setIsOpen(false)} getCode={getCode} />
        </SC.Container>
    )
}

export default CodeEditor
